import React, { Component } from 'react'

import Wallet from "components/Wallet/Wallet";

export default class WalletView extends Component {
    render() {
        return (
            <div className="fade-show">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="header">Mi Billetera</h1>
                    </div>
                </div>

                <Wallet />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/WalletView/WalletView.jsx